export default "__VITE_ASSET__BVGyYGao__"